const EVENT_LOG_API_BASE = '/api/event-log';

export const EVENT_LOG_ENDPOINTS = {
    CREATE: EVENT_LOG_API_BASE,
} as const;
